import { EntityStatus, ServiceOfferingActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get service offerings api for given service id
 * @returns Array of objects as required by service offerings table
 */
export const convertServiceOfferingList = (data) => {
  const list = data.serviceofferings ? data.serviceofferings : [];
  const returnData = [];
  list.forEach((offering) => {
    const object = {
      key: offering.offerid,
      offerid: offering.offerid,
      offeringname: offering.offeringname,
    };
    const instances = offering.serviceinstances;
    if (instances && instances.length) {
      object.instanceData = instances.map((item) => {
        return {
          // data required for table display
          key: item.serviceid + ":" + item.instanceid,
          servicename: item.servicename,
          instancename: item.instancename,
          status: item.offeringstatus,
          // extra data for processing
          serviceid: item.serviceid,
          instanceid: item.instanceid,
          offerid: offering.offerid,
          offeringname: offering.offeringname,
          licenseinfo: item.licenseinfo,
        };
      });
    }
    returnData.push(object);
  });
  return returnData;
};

/**
 * @param {*} formData : service offering form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertServiceOfferingFormToApiValues = (
  formData,
  action = ServiceOfferingActions.add
) => {
  console.log("convertServiceOfferingFormToApiValues", formData);
  const returnData = {
    serviceinstances: [],
  };

  const licenseinfo = {
    scoperestriction: formData.scoperestriction,
  };
  if (!!formData.timeactivation || !!formData.timeduration) {
    licenseinfo.timerestriction = {};
    if (!!formData.timeduration) {
      licenseinfo.timerestriction.duration = formData.timeduration;
      licenseinfo.timerestriction.activationdate = formData.timeactivation;
    }
  }
  if (!!formData.volumerestriction) {
    licenseinfo.volumerestriction = formData.volumerestriction;
  }

  if (formData.instanceTable) {
    formData.instanceTable.forEach((item) => {
      returnData.serviceinstances.push({
        serviceid: item.serviceid,
        instanceid: item.instanceid,
        licenseinfo,
      });
    });
  } else if (formData.instanceid) {
    returnData.serviceinstances.push({
      serviceid: formData.serviceid,
      instanceid: formData.instanceid,
      licenseinfo,
    });
  }
  if (action === ServiceOfferingActions.add) {
    returnData.offeringname = formData.offeringname;
    returnData.offeringstatus = EntityStatus.ACTIVE;
  }
  if (
    action === ServiceOfferingActions.edit ||
    action === ServiceOfferingActions.editInstance
  ) {
    returnData.offerid = formData.offerid;
  }
  return returnData;
};

/**
 * @param {*} data : response from get all service offerings api
 * @returns Array of service offering objects as required by service offerings dropdown
 */
export const convertServiceOfferingListToDropdown = (data) => {
  const list = data.serviceofferings ? data.serviceofferings : [];
  return list.map((item) => {
    return {
      offerId: item.offerid,
      offeringName: item.offeringname,
    };
  });
};
